(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 3049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgDixaLogotype = function SvgDixaLogotype(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "88px",
    height: "39px",
    viewBox: "0 0 88 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, "Group 4")), _desc || (_desc = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    id: "login-c",
    transform: "translate(-869.000000, -701.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    id: "Group-4",
    transform: "translate(869.000000, 701.000000)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M52.824724,10.3331884 C53.2097925,10.3331884 53.5176814,10.6261392 53.5176814,10.9780122 L53.5176814,26.6936233 C53.5176814,27.1434232 53.3060597,27.3583645 52.7857192,27.4363741 C51.2271873,27.7102375 49.6304806,27.8272519 47.8785846,27.8272519 C43.9341214,27.8272519 41.7598118,25.7558485 41.7598118,21.9831724 L41.7598118,20.5756804 C41.7598118,16.7830869 43.8760291,14.7706057 47.8785846,14.7706057 C48.5906295,14.7706057 49.7649226,14.8286979 50.7848564,14.9656297 L50.7848564,10.9780122 C50.7848564,10.6261392 51.1118327,10.3331884 51.4969013,10.3331884 L52.824724,10.3331884 L52.824724,10.3331884 Z M50.6695018,17.2528042 C49.8802772,17.1548773 48.6868966,17.1357898 47.8213222,17.096785 C45.5507455,17.096785 44.588074,18.1914088 44.588074,20.7316995 L44.588074,22.1591089 C44.588074,24.7782391 45.5117407,25.8529455 47.8213222,25.8529455 C48.6487217,25.8529455 49.8230149,25.7948533 50.6695018,25.7367611 L50.6695018,17.2519743 L50.6695018,17.2528042 Z M58.8281421,15.1025614 C59.2513856,15.1025614 59.5982793,15.3955122 59.5982793,15.7664727 L59.5982793,27.1633405 C59.5982793,27.5160434 59.2522155,27.8280817 58.828972,27.8280817 L57.5393243,27.8280817 C57.1160808,27.8280817 56.7691871,27.5351309 56.7691871,27.1641704 L56.7691871,15.7673026 C56.7691871,15.4154296 57.1160808,15.1025614 57.5393243,15.1025614 L58.8281421,15.1025614 L58.8281421,15.1025614 Z M58.8480595,10.3331884 C59.2522155,10.3331884 59.5783619,10.6460566 59.5982793,11.017017 L59.5982793,12.4444264 C59.5982793,12.8153868 59.2522155,13.1282551 58.8480595,13.1282551 L57.5011494,13.1282551 C57.0779059,13.1282551 56.7500997,12.8153868 56.7500997,12.4444264 L56.7500997,11.017017 C56.7500997,10.6460566 57.0969934,10.3331884 57.5003195,10.3331884 L58.8480595,10.3331884 L58.8480595,10.3331884 Z M70.239948,21.2213341 L74.8582812,26.9674867 C74.9744656,27.0845011 75.0126405,27.2214328 75.0126405,27.3782818 C75.0126405,27.5932231 74.8582812,27.8272519 74.4541251,27.8272519 L72.6839716,27.8272519 C72.4341749,27.8272519 72.298903,27.7691596 72.1445436,27.5733058 L68.6233239,23.116801 L65.1021042,27.534301 C64.9095699,27.7691596 64.7942153,27.8272519 64.4863264,27.8272519 L62.946882,27.8272519 C62.5999884,27.8272519 62.4273714,27.5932231 62.4273714,27.3973693 C62.4273714,27.3193597 62.4464589,27.1434232 62.6199057,26.9674867 L67.1419717,21.357436 L62.8697023,16.0021612 C62.7734352,15.8652295 62.6962555,15.7282978 62.6962555,15.5714487 C62.6962555,15.2784979 62.946882,15.0834739 63.2937757,15.0834739 L64.9676621,15.0834739 C65.2556337,15.0834739 65.4489979,15.1996584 65.6597897,15.4934392 L68.7386785,19.4611392 L71.8756595,15.4735218 C72.1453735,15.1614835 72.2798155,15.0834739 72.5877044,15.0834739 L74.0889739,15.0834739 C74.4159502,15.0834739 74.6466594,15.2984152 74.6466594,15.5714487 C74.6466594,15.7282978 74.5503923,15.8652295 74.4732126,15.9822439 L70.2407779,21.2205043 L70.239948,21.2213341 Z M82.3065364,14.7116836 C85.8468435,14.7116836 87.6169971,16.2171025 87.5788222,19.2262806 L87.5788222,26.7135406 C87.5788222,27.1625106 87.3862879,27.3774519 86.8476899,27.4562914 C85.2883281,27.7301548 83.7107088,27.8463393 82.0177349,27.8463393 L81.4401321,27.8463393 C78.2450588,27.8463393 76.6292646,26.5376041 76.6292646,23.9184739 L76.6292646,23.7425374 C76.6292646,21.005563 78.5919525,19.8130122 83.133106,19.8130122 L84.8459972,19.8130122 L84.8459972,19.2271105 C84.8459972,17.4478281 84.1920445,16.842009 82.2675316,16.842009 C80.6119027,16.842009 79.3811771,16.939936 78.3031511,17.0179456 L78.1496216,17.0179456 C77.5139265,17.0179456 77.4757516,16.588063 77.4757516,16.4511313 L77.4757516,15.6494583 C77.4757516,15.3955122 77.6101936,15.082644 78.2259714,15.0046344 C79.2649926,14.8486153 80.4583732,14.7116836 82.3057065,14.7116836 L82.3065364,14.7116836 Z M79.4575269,23.8985566 L79.4575269,23.9375614 C79.4575269,25.3060486 80.0160423,25.8338581 81.5554867,25.8338581 L82.0169051,25.8338581 C82.8061296,25.8338581 83.9032431,25.7757659 84.7306426,25.7168437 L84.7306426,21.866158 L83.0758436,21.866158 C79.9969548,21.866158 79.4575269,22.5109819 79.4575269,23.8993865 L79.4575269,23.8985566 Z M23.459096,19.7358326 L19.5528078,21.9250802 C19.3913895,22.0190615 19.1992311,22.0450169 19.0186636,21.9972288 C18.8380961,21.9494407 18.6839334,21.8318295 18.5901363,21.6703042 L14.0871577,14.0278549 C13.875536,13.6958992 14.0108079,13.2851041 14.3377843,13.0900802 L18.2440725,10.9000027 C20.7453585,9.49334054 23.9205144,10.3141009 25.3645215,12.7572946 C25.8458573,13.5589675 26.0566491,14.43865 26.0566491,15.2984152 C26.052483,17.1372381 25.0604375,18.8319561 23.459096,19.7358326 L23.459096,19.7358326 Z M34.3887363,7.65596594 C30.0799517,0.324725096 20.5154792,-2.17656083 13.029879,2.06500266 L0.713493928,9.02362327 C0.391599699,9.20473629 0.155493479,9.50704714 0.0577577855,9.86322905 C-0.039977908,10.219411 0.00844019199,10.5998861 0.193153424,10.91992 L10.8738269,29.0198026 C11.1045361,29.4115103 11.2198907,29.8413929 11.2198907,30.2911928 L11.2198907,37.8166277 C11.2198907,38.0904911 11.5277796,38.2655977 11.7784061,38.1294959 L15.1270089,36.2331992 L17.4166731,34.9427215 L28.6741195,28.5708325 C33.6775213,25.7359312 36.4866961,20.5756804 36.4866961,15.2984152 C36.4866961,12.6983725 35.813656,10.0601548 34.3895662,7.65513605 L34.3887363,7.65596594 Z",
    id: "Shape"
  }))))));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgDixaLogotype);

/***/ }),

/***/ 7913:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(5696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(7294));

var _router = __webpack_require__(2199);

var _router1 = __webpack_require__(1587);

var _useIntersection = __webpack_require__(7215);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  router.prefetch(href, as, options)["catch"](function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault(); // replace state instead of push if prop is present

  router[replace ? 'replace' : 'push'](href, as, {
    shallow: shallow,
    locale: locale,
    scroll: scroll
  });
}

var Link = /*#__PURE__*/_react["default"].forwardRef(function (props, forwardedRef) {
  var _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(false) !== true : _props$legacyBehavior;

  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      restProps = _objectWithoutProperties(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter"]);

  children = childrenProp;

  if (legacyBehavior && typeof children === 'string') {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }

  var p = prefetchProp !== false;
  var router = (0, _router1).useRouter();

  var _react$default$useMem = _react["default"].useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);

  var previousAs = _react["default"].useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react["default"].useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      }

      if ((0, _router).isLocalURL(href)) {
        prefetch(router, href, as, {
          priority: true
        });
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _router).getDomainLocale(as, curLocale, router && router.locales, router && router.domainLocales);
    childProps.href = localeDomain || (0, _router).addBasePath((0, _router).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 7215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(5696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(7294);

var _requestIdleCallback = __webpack_require__(8065);

var hasIntersectionObserver = typeof IntersectionObserver !== 'undefined';

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;
  var unobserve = (0, _react).useRef();

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(rootRef ? rootRef.current : null),
      _useState4 = _slicedToArray(_useState3, 2),
      root = _useState4[0],
      setRoot = _useState4[1];

  var setRef = (0, _react).useCallback(function (el) {
    if (unobserve.current) {
      unobserve.current();
      unobserve.current = undefined;
    }

    if (isDisabled || visible) return;

    if (el && el.tagName) {
      unobserve.current = observe(el, function (isVisible) {
        return isVisible && setVisible(isVisible);
      }, {
        root: root,
        rootMargin: rootMargin
      });
    }
  }, [isDisabled, root, rootMargin, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  (0, _react).useEffect(function () {
    if (!hasIntersectionObserver) {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [visible]);
  (0, _react).useEffect(function () {
    if (rootRef) setRoot(rootRef.current);
  }, [rootRef]);
  return [setRef, visible, resetVisible];
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements["delete"](element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers["delete"](id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

var observers = new Map();
var idList = [];

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);
  } else {
    instance = observers.get(id);
    idList.push(id);
  }

  if (instance) {
    return instance;
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  observers.set(id, instance = {
    id: id,
    observer: observer,
    elements: elements
  });
  return instance;
}

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 4245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ MainLayout; }
});

// EXTERNAL MODULE: ./src/designSystem/index.tsx + 327 modules
var designSystem = __webpack_require__(8818);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/designSystem/images/dixa-logotype.svg
var dixa_logotype = __webpack_require__(3049);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/mainLayout/mainLayout.tsx





var MainLayout = function MainLayout(_ref) {
  var children = _ref.children,
      asideChildren = _ref.asideChildren;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(designSystem/* Box */.xu, {
    display: "flex",
    alignItems: "center",
    css: "min-height: 100vh; min-height: 100svh;",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(designSystem/* Box */.xu, {
      display: ['none', 'none', 'flex'],
      alignItems: "center",
      flex: "1",
      css: "height: 100vh; height: 100svh;",
      bg: "primary",
      position: "sticky",
      top: 0,
      overflow: "auto",
      alignSelf: "start",
      children: [!asideChildren && /*#__PURE__*/(0,jsx_runtime.jsx)(designSystem/* Box */.xu, {
        margin: "auto",
        padding: 12,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/signin",
          passHref: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(dixa_logotype/* default */.Z, {})
          })
        })
      }), asideChildren]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(designSystem/* Box */.xu, {
      display: "flex",
      flexDirection: "row",
      width: "full",
      maxWidth: ['none', 'none', '50%'],
      flexShrink: 0,
      children: children
    })]
  });
};
;// CONCATENATED MODULE: ./src/components/mainLayout/index.tsx


/***/ }),

/***/ 2779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IndexPage": function() { return /* binding */ IndexPage; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var src_components_mainLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);




function IndexPage() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var query = router.query;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (!router.isReady) return;
    router.push({
      pathname: '/signin',
      query: query
    });
  }, [router, query]);
  return null;
}

IndexPage.getLayout = function (page) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_mainLayout__WEBPACK_IMPORTED_MODULE_2__/* .MainLayout */ .Z, {
    children: page
  });
};

/* harmony default export */ __webpack_exports__["default"] = (IndexPage);

/***/ }),

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2779);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7913)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);